import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

const IMPLIED_ACTIONS = ['view', 'create', 'edit', 'manage', 'approve'];

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return authorizedResources.reduce<AuthorizedResourceAccessMap>(
    (accumulator, resource) => {
      if (!resource?.code) {
        return accumulator;
      }

      const allowed = isAuthorizedResourceAllowed(resource.effect);

      accumulator[resource.code] = allowed;

      const actions = resource.actions ?? [];
      actions.forEach((action) => {
        if (action) {
          accumulator[`${resource.code}:${action}`] = allowed;
        }
      });

      // IAM treats an empty action set and `manage` as full access; keep route
      // and button checks consistent with the BFF guard.
      if (!actions.length || actions.includes('manage')) {
        IMPLIED_ACTIONS.forEach((action) => {
          accumulator[`${resource.code}:${action}`] = allowed;
        });
      }

      return accumulator;
    },
    {},
  );
}
